import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {scnv}           from "@Common/react/state-change-nested-value";
import {ConfirmModal}   from "@Common/ui-components/confirm-modal/confirm-modal";
import {omit}           from "@Common/utils/objects";

import {BlobToFile}          from "@Xpresso/routes/account/common/blob-to-file";
import {ImageAssetEditModal} from "@Xpresso/routes/account/common/image-asset-edit-modal/image-asset-edit-modal";

export const LogoDisplay = ({logos, selectedLogos, calValue, agentId, next}) => cs(
    consumeContext("apis"),
    ["deleteLogo", ({apis}, next) => cs(
        ["confirmModal", (_, next) => ConfirmModal({next})],
        ({confirmModal}) => next((logo) => new Promise((resolve) => {
            confirmModal.show({
                messageLines: ["Are you sure you want to delete this logo?"],
                confirm: async () => {
                    await apis.next.gallery.logos.delete(logo.id, {agentId});
                    logos.change((_) => _.filter((logo1) => logo1.id !== logo.id));
                    scnv(selectedLogos, ["current"], (_) => _?.filter((url) => url !== logo.printUrl));
                    resolve(true);
                }
            });
        })),
    )],
    ["editModal", ({deleteLogo, apis}, next) => ImageAssetEditModal({
        agentId,
        onRemoveBackground: (data, result) => {
            logos.change((_) => [..._??[], result]);
            if (calValue?.includes(data.printUrl)) {
                scnv(selectedLogos, ["current"], () => [result.printUrl]);
            }
            logos.reload();
        },
        onEdit: async ({id, data}) => {
            // console.log("data", data);

            const logo = logos.value.find((logo) => logo.id === id);

            if (!!data.defaultSlot !== calValue?.includes(logo.printUrl)) {
                scnv(selectedLogos, ["current"], () => data.defaultSlot ? [logo.printUrl] : []);
            }

            await apis.next.gallery.logos.update({
                id,
                postData: omit(data, ["defaultSlot"]),
                agentId,
            });

            logos.reload();
        },
        onImageEdit: async ({mimeString, name: suggestedName, content, printUrl, defaultSlot}) => {
            const name = (() => {
                for (let i = 0; ; i++) {
                    const proposedName = suggestedName + (i === 0 ? "" : `(${i})`);
                    if (!logos.value.some((logo) => logo.name === proposedName)) {
                        return proposedName;
                    }
                }
            })();

            const result = await apis.next.gallery.logos.upload({
                agentId,
                formData: {
                    file: BlobToFile({
                        name: name + ".png",
                        data: content,
                        mimeString,
                    }),
                    name,
                    defaultSlot: defaultSlot
                },
            });
            if (result.errorMessage) {
                alert(result.errorMessage);
            } else {
                logos.change((_) => [..._??[], result]);
                if (calValue?.includes(printUrl)) {
                    scnv(selectedLogos, ["current"], () => [result.printUrl]);
                }
                logos.reload();
            }
        },
        onDelete: async (modal) => {
            await deleteLogo(modal.data);
            modal.close();
        },
        allowDefaultOption: 1,
        next,
    })],
    ({deleteLogo, editModal}) => next({deleteLogo, editModal}),
);
